// extracted by mini-css-extract-plugin
module.exports = {"container":"On-z","copy":"Pn-z","field":"Qn-z","error":"Rn-z","disabled":"Sn-z","termsContainer":"Tn-z","termsHeading":"Un-z","termsCopy":"Vn-z","submit":"Wn-z","srOnly":"Xn-z"};